const routes = [
  {
    path: '/preferences',
    name: 'preferences',
    component: () => import(
      /* webpackChunkName: "Preferences" */
      '@/modules/Preferences/Preferences.vue'
    ),
    meta: {
      mainClasses: 'App-main__withall',
      hideAside: false,
      hideFooter: true,
      requiresAuth: true,
      accountSettingsPage: true,
      requiresAccountSelected: true,
    },
  },
];

export default routes;
